{"id":"ProductDetail.Info.ShowMore","prefabs":{"default":{"children":[{"component":"ProductDetail.Info.ShowMore","options":"options:*"}]}}}